import { api } from "./client";
import type { AuthUser } from "../store/auth";

export interface LoginResponse {
  access: string;
  refresh: string;
  user: AuthUser;
  must_change_password: boolean;
}

export const authApi = {
  login: (identifier: string, password: string) =>
    api.post<LoginResponse>("/auth/login/", { identifier, password }).then((r) => r.data),
  logout: (refresh: string) => api.post("/auth/logout/", { refresh }),
  changePassword: (current_password: string, new_password: string) =>
    api.post("/auth/change-password/", { current_password, new_password }).then((r) => r.data),
  me: () => api.get<AuthUser>("/auth/me/").then((r) => r.data),
};
